<template>
  <div class="DataCenter">
    <div>
      <div class="main">
        <div>
          <p><b>联系人</b>：曹老师</p>
          <p><b>联系地址</b>：北京市新街口外大街19号（北京师范大学心理学部）</p>
          <p><b>联系邮箱</b>：PYD_China@126.com</p>
        </div>
        <baidu-map
          class="map"
          :center="{lng:116.37198,lat:39.967123}"
          :zoom="15"
          :scroll-wheel-zoom="true"
        >
          <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
          <bm-marker
            :position="{lng:116.37198,lat:39.967000}"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          >
            <bm-label
              content="北京师范大学"
              :labelStyle="{color:'red',fontSize:'12px'}"
              :offset="{width:-35,height:30}"
            />
          </bm-marker>
        </baidu-map>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DataCenter",
  data () {
    return {
      
    }
  },
  
};
</script>
<style scoped>
.DataCenter>div{
    width: 80%;
    margin: 20px auto
  }
.main {
    display: inline-block;
    width: 100%;
}
.main>div{
  display: inline-block
}
.main>div:first-child{
  width: 36%;
}
.map {
  width: 60%;
  height: 600px;
  float: right
}
.main>div p{
  font-size: 24px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue